import clsx from 'clsx';

import styles from './Tag.module.css';

export type TStatus = 'red' | 'green' | 'orange' | 'purple' | 'blue' | 'gray';

type TagProps = {
  children: React.ReactNode;
  status: TStatus;
  block?: boolean;
  style?: React.CSSProperties;
  className?: string;
};

export function Tag({ children, status, block, style, className }: TagProps) {
  return (
    <div className={clsx(styles.tag, styles[status], block && styles.block, className)} style={style}>
      {children}
    </div>
  );
}
